module.exports = __webpack_public_path__ + "static/media/water-2.a44777fe.svg";